import React from 'react';
import '../../src/bootstrap.css';
import Introduction from '../components/Introduction'


const Page = () => {
 return (
  <>
   <h3 className="text-dark text-center my-3">Welcome to our page</h3>
   {/* <HeroSection /> */}
   {/* <Cards /> */}
   {/* <Footer /> */}
   <Introduction />
  </>
 )
}

export default Page